import { AnimationEvent } from '@angular/animations';

import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  DEFAULT_LAYOUT_STATE,
  DEFAULT_PAGE_TITLE_STATE,
  LayoutState,
  PageTitleState
} from '@models/layout-state.model';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { LayoutMediatorService } from '@services/view/layout-mediator-service/layout-mediator.service';
import { GenericErrorComponent } from '@shared-components/error/generic-error/generic-error.component';
import { FluidPageTitleComponent } from '@shared-components/fluid-page-title/fluid-page-title.component';
import { FooterBarComponent } from '@shared-components/footer-bar/footer-bar.component';
import { HeaderBarComponent } from '@shared-components/header-bar/header-bar.component';
import { Subscription } from 'rxjs';
import { ViewService } from 'tangoe-design-system';

import { routerAnimation } from './shared/animations/router.animations';

@Component({
  selector: 'ts-root',
  templateUrl: './app.component.html',
  animations: [routerAnimation],
  imports: [
    RouterOutlet,
    HeaderBarComponent,
    FooterBarComponent,
    FluidPageTitleComponent,
    GenericErrorComponent
  ]
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  @HostBinding('class') class: string = 'd-contents';
  @ViewChild('scrollableElement') scrollable_element: ElementRef;
  @ViewChild('contentContainer') content_container: ElementRef;
  @ViewChild('errorContainer') error_container: ElementRef;
  error: string | undefined = undefined;
  layout_state: LayoutState = { ...DEFAULT_LAYOUT_STATE };
  page_title_state: PageTitleState = { ...DEFAULT_PAGE_TITLE_STATE };
  page_title_content: TemplateRef<any> | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private layout_mediator: LayoutMediatorService,
    private view_svc: ViewService,
    renderer: Renderer2,
    tooltip_config: NgbTooltipConfig
  ) {
    tooltip_config.openDelay = 300;
    tooltip_config.closeDelay = 500;
    tooltip_config.autoClose = true;
    tooltip_config.animation = true;
    tooltip_config.container = 'body';

    this.view_svc.setRenderer(renderer);
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.layout_mediator.layoutState().subscribe((state: LayoutState) => {
        this.layout_state = state;
      })
    );

    this.subscriptions.add(
      this.layout_mediator.pageTitleState().subscribe((state: PageTitleState) => {
        this.page_title_state = state;
      })
    );

    this.subscriptions.add(
      this.layout_mediator.pageTitleContent().subscribe((content: TemplateRef<any> | null) => {
        this.page_title_content = content;
      })
    );

    this.subscriptions.add(
      this.layout_mediator.error().subscribe((error: string | undefined) => {
        this.error = error;
      })
    );
  }

  ngAfterViewInit(): void {
    this.view_svc.setScrollableElement(this.scrollable_element.nativeElement);
    this.view_svc.setContentContainer(this.content_container.nativeElement);
    this.view_svc.setErrorContainer(this.error_container.nativeElement);
    this.view_svc.toggleClass(this.content_container.nativeElement, 'd-none', Boolean(this.error));
    this.view_svc.toggleClass(this.error_container.nativeElement, 'd-none', !this.error);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onRouterAnimationStart(event: AnimationEvent): void {
    this.view_svc.resetScrollPosition();
  }
}
